// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/@angular-devkit/build-angular/node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/@angular-devkit/build-angular/node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.pageDIV {
    padding-bottom: 20px;
}

    .pageDIV > .pageInnerDIV {
        align-items: center;
        margin-bottom: 15px;
    }

        .pageDIV > .pageInnerDIV .pageLayout {
            box-shadow: 10px 5px 5px black;
        }

    .pageEditRow > * {
        align-self: center;
    }

.editBox {
    position: sticky;
    top: 0px;
    width: 200px;
    align-self: flex-start;
}

.multiGrid .editBox {
    margin-right: 5px;
}

    .multiGrid .editBox > * {
        align-self: flex-end;
    }

.multiGrid {
    display: grid;
    grid-template-columns: auto max-content;
    grid-template-rows: auto;
    margin-bottom: 15px;
}

    .multiGrid > * {
        grid-row: 1;
        grid-column-end: 3;
    }

.multiGridPageContent {
    grid-column-start: 1;
    display: grid;
    grid-template-columns: auto;
    grid-template-rows: auto;
}

    .multiGridPageContent > * {
        grid-row: 1;
        grid-column: 1;
    }`, "",{"version":3,"sources":["webpack://./src/app/settings/output/output.settings.css"],"names":[],"mappings":"AAAA;IACI,oBAAoB;AACxB;;IAEI;QACI,mBAAmB;QACnB,mBAAmB;IACvB;;QAEI;YACI,8BAA8B;QAClC;;IAEJ;QACI,kBAAkB;IACtB;;AAEJ;IACI,gBAAgB;IAChB,QAAQ;IACR,YAAY;IACZ,sBAAsB;AAC1B;;AAEA;IACI,iBAAiB;AACrB;;IAEI;QACI,oBAAoB;IACxB;;AAEJ;IACI,aAAa;IACb,uCAAuC;IACvC,wBAAwB;IACxB,mBAAmB;AACvB;;IAEI;QACI,WAAW;QACX,kBAAkB;IACtB;;AAEJ;IACI,oBAAoB;IACpB,aAAa;IACb,2BAA2B;IAC3B,wBAAwB;AAC5B;;IAEI;QACI,WAAW;QACX,cAAc;IAClB","sourcesContent":[".pageDIV {\n    padding-bottom: 20px;\n}\n\n    .pageDIV > .pageInnerDIV {\n        align-items: center;\n        margin-bottom: 15px;\n    }\n\n        .pageDIV > .pageInnerDIV .pageLayout {\n            box-shadow: 10px 5px 5px black;\n        }\n\n    .pageEditRow > * {\n        align-self: center;\n    }\n\n.editBox {\n    position: sticky;\n    top: 0px;\n    width: 200px;\n    align-self: flex-start;\n}\n\n.multiGrid .editBox {\n    margin-right: 5px;\n}\n\n    .multiGrid .editBox > * {\n        align-self: flex-end;\n    }\n\n.multiGrid {\n    display: grid;\n    grid-template-columns: auto max-content;\n    grid-template-rows: auto;\n    margin-bottom: 15px;\n}\n\n    .multiGrid > * {\n        grid-row: 1;\n        grid-column-end: 3;\n    }\n\n.multiGridPageContent {\n    grid-column-start: 1;\n    display: grid;\n    grid-template-columns: auto;\n    grid-template-rows: auto;\n}\n\n    .multiGridPageContent > * {\n        grid-row: 1;\n        grid-column: 1;\n    }"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
